import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssignToStateService {
  private selectedAdjusterSubject = new BehaviorSubject<string | null>(null);
  selectedAdjuster$ = this.selectedAdjusterSubject.asObservable();

  setSelectedAdjuster(adjusterId: string) {
    this.selectedAdjusterSubject.next(adjusterId);
  }
}